import { Loader } from "@mantine/core";

const PageLoading = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4">
      <Loader size="lg" color="primary" />
    </div>
  );
};

export default PageLoading;
